// A super-selector that returns all the current data needed for a tick of the ETH monitor.

export default function getDeriveDataNeededForTick(aci) {
  return async function ({ assetName, walletAccount }) {
    const receiveAddress = await aci.getReceiveAddress({ assetName, walletAccount, useCache: true })
    const currentAccountState = await aci.getAccountState({ assetName, walletAccount })
    const minimumConfirmations = await aci.getConfirmationsNumber({ assetName })
    return {
      ourWalletAddress: receiveAddress.toLowerCase(),
      currentAccountState,
      minimumConfirmations,
    }
  }
}
